module.exports = __webpack_public_path__ + "static/media/close.65f7d121.png";